import { Component } from '@angular/core';
import { PAGE_NAME } from '../../services/event.permissions.service';
import { JoiEvent, MediaTerms, Ranking } from 'globals/store/events.data';
import { attendeeBriefProgramPublishSelectionsReselector, briefLogisticsSelectionsReselector, briefSharesSelectionsReselector, exhibitorBriefProgramPublishSelectionsReselector, performerBriefProgramPublishSelectionsReselector, resourceBriefProgramPublishSelectionsReselector } from 'src/app/store/reselectors/publish.reselector';
import { removeOrAddToListByElement } from '../../helpers/helpers';
import { colorsByPublishStatus } from 'src/app/helpers/table-helpers';
import { LogisticsInBriefSelection, PublishInBriefSelection } from 'globals/store/publish.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Dictionary } from '@ngrx/entity';
import { titleCase } from './../../helpers/helpers';
import { Observable } from 'rxjs';
import { MemoizedSelector } from '@ngrx/store';
import { CoreEntityType } from 'globals/store/share.data';
import { InformableType } from 'globals/store/informables.data';
import { mediaTermsReselector } from 'src/app/store/reselectors/entity.reselector';
import { readOnlyReselector } from 'src/app/store/reselectors/permissions.reselector';
import { createMediaTerms } from 'globals/store/events.data';
import { EntityConfigureSubpage, entityConfigureSubpageNames } from 'globals/store/entity.data';
import { traceNames, TraceNameType } from 'src/app/services/performance.tracking.data';
import { attendeesFeature } from 'src/app/store/attendees.era';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { TopMenuComponent } from 'src/app/modules/program/top.menu';
import { MobileMenuComponent } from '../menu/mobile-menu.component';
import { JoiNavWrapper } from '../wrappers/joi-nav-wrapper.component';
import { TipTextComponent } from '../misc/tip-text.component';
import { CustomQuestionManagerComponent } from './custom-question-manager.component';
import { InformableComponent } from '../informable/informable.component';
import { TitleToggleComponent } from '../wrappers/title-toggle-wrapper.component';
import { TitleStatusToggleComponent } from '../wrappers/title-status-toggle.component';
import { EntityTypeDropdownComponent } from './entity-type-dropdown.component';
import { MediaTermsComponent } from '../performers/mediaTerms.component';
import { SubmittedEntitiesComponent } from './submitted-entities.component';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'entity-information-page',
    templateUrl: './entity-information.html',
    styleUrls: ['./entity.information.scss', '../../page.scss'],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, MatButtonModule, CommonModule, TitleCasePipe, SubmittedEntitiesComponent, MediaTermsComponent, EntityTypeDropdownComponent, TitleStatusToggleComponent, TitleToggleComponent, TopMenuComponent, MobileMenuComponent, JoiNavWrapper, TipTextComponent, CustomQuestionManagerComponent, InformableComponent],
})
export class EntityInformationPageComponent extends Wrapper<EntityInformationPageComponent> {
  entityType: CoreEntityType
  entityTitle: string
  informableType: InformableType
  traceName: TraceNameType
  mediaTerms: MediaTerms[] = []

  PAGE_NAME = PAGE_NAME
  event: JoiEvent
  

  entityConfigureSubpageNames = entityConfigureSubpageNames;
  colorsByPublishStatus = colorsByPublishStatus
  entityTypes: Dictionary<Ranking> = {}
  publishIdsKey: keyof Pick<JoiEvent, 'publishIdsToShowInExhibitorBrief' | 'publishIdsToShowInResourceBrief' | 'publishIdsToShowInPerformerBrief' | 'publishIdsToShowInAttendeeBrief'>
  showPublishesKey: keyof Pick<JoiEvent, 'showPublishedProgramsInExhibitorBrief' | 'showPublishedProgramsInPerformerBrief' | 'showPublishedProgramsInResourceBrief' | 'showPublishedProgramsInAttendeeBrief'>
  logisticsIdsKey: keyof Pick<JoiEvent, 'eBriefLogIds' | 'rBriefLogIds' | 'pBriefLogIds' | 'aBriefLogIds'>
  showLogisticsKey: keyof Pick<JoiEvent, 'showLogisticsInEBrief' | 'showLogisticsInPBrief' | 'showLogisticsInRBrief' | 'showLogisticsInABrief'>
  showShareKey: keyof Pick<JoiEvent, 'showShareInEBrief' | 'showShareInPBrief' | 'showShareInRBrief' | 'showShareInABrief'>
  shareIdsKey: keyof Pick<JoiEvent, 'eShareLogIds' | 'pShareLogIds' | 'rShareLogIds' | 'aShareLogIds'>
  traceNames = traceNames
  readOnly: boolean = true
  subTab: EntityConfigureSubpage = 'briefInfo'
  subTabs: EntityConfigureSubpage[] = ['briefInfo', 'customQuestions', 'submissions']
  publishes: PublishInBriefSelection[] = []
  logistics: LogisticsInBriefSelection[] = []
  shares: LogisticsInBriefSelection[] = []
  
  constructor(){
    super()

    this.selectProp(readOnlyReselector, null, 'readOnly')
    const url = this.router.url
    if (url.includes('performer')) this.entityType = 'performer'
    else if (url.includes('exhibitor')) this.entityType = 'exhibitor'
    else if (url.includes('resource')) this.entityType = 'resource'
    else if (url.includes('attendee')) this.entityType = 'attendee'
    else {
      console.error("No handling for entity type!")
      return 
    }

    this.subProp(this.store.select('events','event'), 'event')
    this.entityTitle = titleCase(this.entityType)
    this.uiService.changePageTitle(`${this.entityTitle} Information`, true)

    let typesObservable: Observable<{ [id:string]: Ranking }>
    let publishesReselector: MemoizedSelector<any, PublishInBriefSelection[]> 

    switch (this.entityType) {
      case 'attendee':
        typesObservable = this.store.select(attendeesFeature.selectAttendeeTypes)
        publishesReselector = attendeeBriefProgramPublishSelectionsReselector
        this.publishIdsKey = 'publishIdsToShowInAttendeeBrief'
        this.showPublishesKey = 'showPublishedProgramsInAttendeeBrief'
        this.logisticsIdsKey = 'aBriefLogIds'
        this.showShareKey = 'showShareInABrief'
        this.shareIdsKey = 'aShareLogIds'
        this.showLogisticsKey = 'showLogisticsInABrief'
        this.traceName = this.traceNames.viewAttendeeConfigure
        this.informableType = 'attendees'
        break
      case 'performer':
        typesObservable = this.store.select('performers', 'performerTypes')
        publishesReselector = performerBriefProgramPublishSelectionsReselector
        this.publishIdsKey = 'publishIdsToShowInPerformerBrief'
        this.showPublishesKey = 'showPublishedProgramsInPerformerBrief'
        this.logisticsIdsKey = 'pBriefLogIds'
        this.showShareKey = 'showShareInPBrief'
        this.shareIdsKey = 'pShareLogIds'
        this.showLogisticsKey = 'showLogisticsInPBrief'
        this.traceName = this.traceNames.viewPerformerInformation
        this.informableType = 'performers'
        break
      case 'exhibitor':
        typesObservable = this.store.select('exhibitors', 'exhibitorTypes')
        publishesReselector = exhibitorBriefProgramPublishSelectionsReselector
        this.publishIdsKey = 'publishIdsToShowInExhibitorBrief'
        this.showPublishesKey = 'showPublishedProgramsInExhibitorBrief'
        this.logisticsIdsKey = 'eBriefLogIds'
        this.showLogisticsKey = 'showLogisticsInEBrief'
        this.showShareKey = 'showShareInEBrief'
        this.shareIdsKey = 'eShareLogIds'
        this.traceName = this.traceNames.viewExhibitorInformation
        this.informableType = 'exhibitors'
        break
      case 'resource':
        typesObservable = this.store.select('resources', 'resourceTypes')
        publishesReselector = resourceBriefProgramPublishSelectionsReselector
        this.publishIdsKey = 'publishIdsToShowInResourceBrief'
        this.showPublishesKey = 'showPublishedProgramsInResourceBrief'
        this.logisticsIdsKey = 'rBriefLogIds'
        this.showLogisticsKey = 'showLogisticsInRBrief'
        this.showShareKey = 'showShareInRBrief'
        this.shareIdsKey = 'rShareLogIds'
        this.traceName = this.traceNames.viewResourceInformation
        this.informableType = 'resources'
        break
      default:
        console.log(`Missing information initialization for ${this.entityType}`)
        return
    }

    this.subProp(typesObservable, 'entityTypes')
    this.subProp(this.store.select(publishesReselector), 'publishes')
    this.selectProp(briefLogisticsSelectionsReselector, this.entityType === 'exhibitor' ? 'eBriefLogIds' : this.entityType === 'resource' ? 'rBriefLogIds' : this.entityType === 'attendee' ? 'aBriefLogIds' : 'pBriefLogIds', 'logistics')
    this.selectProp(briefSharesSelectionsReselector, this.entityType === 'exhibitor' ? 'eShareLogIds' : this.entityType === 'resource' ? 'rShareLogIds' : this.entityType === 'attendee' ? 'aShareLogIds' : 'pShareLogIds', 'shares')
    this.selectProp(mediaTermsReselector, { type: this.entityType }, 'mediaTerms')
  }

  togglePublish(publishCode: string) {
    const ids = this.event[this.publishIdsKey]
    removeOrAddToListByElement(ids, publishCode)
    this.eventService.updateEvent(this.event.eventId, { [this.publishIdsKey]: ids })
  }

  toggleLogistics(code: string) {
    const ids = this.event[this.logisticsIdsKey]
    removeOrAddToListByElement(ids, code)
    this.eventService.updateEvent(this.event.eventId, { [this.logisticsIdsKey]: ids })
  }

  toggleShares(code: string) {
    const ids = this.event[this.shareIdsKey]
    removeOrAddToListByElement(ids, code)
    this.eventService.updateEvent(this.event.eventId, { [this.shareIdsKey]: ids })
  }


  toggleIncludePublishes(toggled: boolean) {
    this.eventService.updateEvent(this.event.eventId, { [this.showPublishesKey]: toggled })
  }

  toggleIncludeLogistics(toggled: boolean) {
    this.eventService.updateEvent(this.event.eventId, { [this.showLogisticsKey]: toggled })
  }

  toggleIncludeShares(toggled: boolean) {
    this.eventService.updateEvent(this.event.eventId, { [this.showShareKey]: toggled })
  }

  updatePublishEntityTypes(publish: PublishInBriefSelection, ids: string[]) {
    const publishEntityKeys = this.event.publishEntityKeys
    publishEntityKeys[`${this.entityType}-${publish.publishCode}`] = ids
    this.eventService.updateEvent(this.event.eventId, { publishEntityKeys })
  }

  updateLogisticsEntityTypes(log: LogisticsInBriefSelection, ids: string[]) {
    const logisticsEntityKeys = this.event.logisticsEntityKeys
    logisticsEntityKeys[`${this.entityType}-${log.code}`] = ids
    this.eventService.updateEvent(this.event.eventId, { logisticsEntityKeys })
  }

  updateShareEntityTypes(log: LogisticsInBriefSelection, ids: string[]) {
    const shareEntityKeys = this.event.shareEntityKeys
    shareEntityKeys[`${this.entityType}-${log.code}`] = ids
    this.eventService.updateEvent(this.event.eventId, { shareEntityKeys })
  }


  addTerms() {
    const { mediaTerms, eventId } = this.event
    mediaTerms[this.entityType].push(createMediaTerms())
    this.eventService.updateEvent(eventId, { mediaTerms })
  }



}